import { render, staticRenderFns } from "./tasimatipi.vue?vue&type=template&id=0633a3ee"
import script from "./tasimatipi.vue?vue&type=script&lang=js"
export * from "./tasimatipi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports